import apiFetch from '../apiFetch'

export default function (value, token) {
  return apiFetch({endPoint: `CargaIndex`, method: 'POST', body: value, token: token})
}
